import { urls } from "common/urls";
import gql from "graphql-tag";
import { GetStudyProgrammeElementIconFragment } from "__generated__/types";

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
gql`
  fragment GetStudyProgrammeElementIconFragment on StudyProgrammeElement {
    content {
      id
      title
    }
  }
`;

export function getStudyProgrammeElementUrl(
  element: GetStudyProgrammeElementIconFragment,
): string {
  switch (element.content.__typename) {
    case "Folder":
      return urls.folder(element.content.id);
    case "ExamSyllabus":
      return urls.exam(element.content.id);
    case "Kurssloeyfe":
    case "MultipleChoice":
    case "Article":
    case "StudyProgramme":
      return "";
  }
}
